import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '@unity/services/navigation.service';
import { PermissionService } from '@unity/services/permission.service';
import { InsideUnityRoute } from '@unity/utils/types';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private readonly permissionService = inject(PermissionService);
  private readonly navigationService = inject(NavigationService);

  public canActivate(route: ActivatedRouteSnapshot & InsideUnityRoute, _state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (!route.data.authorize) {
      return true;
    }

    const isAllowed = this.permissionService.userIsEntitled(route.data.authorize);

    if (!isAllowed) {
      return this.navigationService.notFound();
    }
    return true;
  }
}
